/**
 * 用户模块 请求 api
 */
// 引入工具函数
import req from '@/utils/request';

// 获取用户列表
export const userList = (params) => {
  return req.get('/system/user/list', params);
}

// 新增用户
export const userAdd = (params) => {
  return req.post('/system/user', params);
}

// 修改用户信息
export const userEdit = (params) => {
  return req.put('/system/user', params);
}

// 查询用户详细信息
export const userInfo = (userId) => {
  return req.get(`/system/user/${userId}`);
}

// 删除用户信息
export const userDelete = (userId) => {
  return req.delete(`/system/user/${userId}`);
}

// 修改密码
export const pwdModify = (params) => {
  return req.put(`/system/user/resetPwd`, params);
}

// 用户停职
export const userDimission = (params) => {
  return req.put(`/system/user/changeStatus`, params);
}
// 查询当前医助理，所属医馆下的医生
export const doctorUnderHospital = (params) => {
  return req.post(`/system/user/doctorUnderHospital`, params);
}
//通过名字查询用户列表
export const getUserList = (params) => {
  return req.get(`/manage/team/teamUserList`, params);
}